import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { whatsappLink, WhatsAppIcon } from "@/lib/whatsapp";

function rupee(n) {
  return `₹${Number(n).toLocaleString("en-IN")}`;
}

export default function ProductCard({ product, className = "" }) {
  const { isWishlisted, toggle } = useWishlist();
  const active = isWishlisted(product.id);
  const dmForPrice = !product.price || product.price === 0;

  return (
    <div className={`group relative ${className}`} data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block">
        <div className="relative hover-zoom bg-[#F3EAE8] aspect-[3/4]">
          <img src={product.images?.[0]} alt={product.name} className="w-full h-full object-cover" loading="lazy" />
          {product.compare_at_price && (
            <div className="absolute top-4 left-4 bg-[#FDFBF7] text-[10px] tracking-overline uppercase px-2.5 py-1 rounded-sm">
              Offer
            </div>
          )}
          {product.tags?.includes("new") && (
            <div className="absolute top-4 right-4 bg-[#1C1917] text-[#FDFBF7] text-[10px] tracking-overline uppercase px-2.5 py-1 rounded-sm">
              New
            </div>
          )}
        </div>
      </Link>
      <button
        onClick={() => toggle(product)}
        data-testid={`wishlist-toggle-${product.id}`}
        aria-label="Wishlist"
        className="absolute bottom-[88px] right-3 w-9 h-9 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow-sm transition hover:scale-105"
      >
        <Heart size={16} strokeWidth={1.3} fill={active ? "#D4AF37" : "none"} color={active ? "#D4AF37" : "#1C1917"} />
      </button>

      <div className="mt-4 px-1">
        <Link to={`/product/${product.id}`} className="block">
          <h3 className="font-serif-h text-lg text-stone-900 leading-snug line-clamp-1">{product.name}</h3>
        </Link>
        <div className="text-[11px] tracking-overline uppercase text-stone-500 mt-1">{product.category}</div>
        {dmForPrice ? (
          <a
            href={whatsappLink(product.name)}
            target="_blank"
            rel="noreferrer"
            onClick={(e) => e.stopPropagation()}
            data-testid={`whatsapp-dm-${product.id}`}
            className="mt-2 inline-flex items-center gap-2 text-[11px] tracking-overline uppercase text-[#1C1917] hover:text-[#25D366] transition-colors"
          >
            <WhatsAppIcon size={14} className="text-[#25D366]" />
            DM for Price
          </a>
        ) : (
          <div className="flex items-baseline gap-2 mt-2">
            <div className="text-stone-900 font-medium text-sm">{rupee(product.price)}</div>
            {product.compare_at_price && (
              <div className="text-stone-400 line-through text-xs">{rupee(product.compare_at_price)}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
